import { action_options, app_modules } from "helpers/apps_modules_list";
import ProductSalesOrderForm from "pages/SalesOrder/Product/Forms/ProductSalesOrderCreateForm";
import SalesOrderProductPage from "pages/SalesOrder/Product/List/SalesOrderProduct";
import SalesOrderServicePage from "pages/SalesOrder/Services/List/SalesOrderServices";
// import ServicesSalesOrderForm from "pages/SalesOrder/Services/Forms/SalesOrderCreateForm";
import ProductSalesOrderEditForm from "pages/SalesOrder/Product/Forms/ProductSalesOrderEditForm";
import ServiceSalesOrderEditForm from "pages/SalesOrder/Services/Forms/ServiceSalesOrderEditForm";
import ViewProductSalesOrderPage from "pages/SalesOrder/Product/View/ViewSalesOrderPage";
import ViewServiceSalesOrderPage from "pages/SalesOrder/Services/View/ViewServiceSalesOrderPage";
import ServicesSalesOrderForm from "pages/SalesOrder/Services/Forms/ServicesSalesOrderCreateForm";
import ChallanPage from "pages/SalesOrder/Services/Challan/index";
import ViewChallanPage from "pages/SalesOrder/Services/Challan/view";
import ReturnAccessories from "pages/SalesOrder/Services/Challan/ReturnAccessories";
import ReturnAccessoriesView from "pages/SalesOrder/Services/Challan/ReturnAccessoriesView";
import EditReturnAccessories from "pages/SalesOrder/Services/Challan/EditReturnAccessories";

const SalesOrderRoutes: any = [
  // Listing Routes
  {
    path: "/sales_order/service/:tab",
    component: <SalesOrderServicePage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.view,
    },
  },
  {
    path: "/sales_order/product/:tab",
    component: <SalesOrderProductPage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.product,
      action: action_options?.view,
    },
  },

  // Create Routes
  {
    path: "/sales_order/add_product_sales_order",
    component: <ProductSalesOrderForm />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.product,
      action: action_options?.create,
    },
  },
  {
    path: "/sales_order/add_services_sales_order",
    component: <ServicesSalesOrderForm />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.create,
    },
  },

  // View Routes
  {
    path: "/sales_order/product/:activeTab/view/:id",
    component: <ViewProductSalesOrderPage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "/sales_order/service/:activeTab/view/:id",
    component: <ViewServiceSalesOrderPage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.view,
    },
  },

  // Edit Routes
  {
    path: "/sales_order/product/edit/:id",
    component: <ProductSalesOrderEditForm />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.product,
      action: action_options?.update,
    },
  },
  {
    path: "/sales_order/service/edit/:id",
    component: <ServiceSalesOrderEditForm />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.update,
    },
  },
  {
    path: "/sales_order/service/challan/return/:challanId",
    component: <ReturnAccessories />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.update,
    },
  },
  {
    path: "/sales_order/service/challan/return-view/:challanId",
    component: <ReturnAccessoriesView />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.view,
    },
  },
  {
    path: "/sales_order/service/challan/return-edit/:challanId/:returnId",
    component: <EditReturnAccessories />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.update,
    },
  },
  {
    path: "/sales_order/service/challan/view/:id",
    component: <ViewChallanPage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.view,
    },
  },
  {
    path: "/sales_order/service/challan/:id",
    component: <ChallanPage />,
    permissions: {
      app_name: app_modules.sales_order.app_name,
      module_name: app_modules.sales_order.modules.service,
      action: action_options?.update,
    },
  },
];

export default SalesOrderRoutes;
